import { MapfreModalComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AcmicService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { PaperlessService } from '.././../../../../_services/_iam/paperless.service';
import { Router , RouterModule } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent],
  selector: 'app-paperles-popup',
  templateUrl: './paperles-popup.component.html',
  styleUrls: ['./paperles-popup.component.scss'],
})
export class PaperlesPopupComponent implements OnInit {
  paperlessModalOptions: ModalOptions;
  hideModal = false;
  eligiblePolicies: string;
  isAcmic: boolean;
  constructor(
    private paperlessService: PaperlessService,
    private router: Router,
    private acmicService: AcmicService,
  ) {
    this.eligiblePolicies = '';
    this.isAcmic = this.acmicService.isACMIC();
  }

  ngOnInit(): void {
    this.paperlessService.$eligiblePolicies.subscribe((policies) => {
      if (policies.length) {
        this.eligiblePolicies = policies.join(',');
      }
    });
    this.paperlessModalOptions = new ModalOptions({
      additionalClasses: 'p-l-popup modal-dialog center-on-page',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'paperlessPopupModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      screenReader: true,
      showIcons: true,
      modalName: 'paperless_Popup',
    });
  }

  hideOnClick() {
    this.hideModal = !this.hideModal;
    const user = JSON.parse(localStorage.getItem('currentUser'));
    this.paperlessService
      .snoozePaperlessPopup(user.username, this.eligiblePolicies)
      .subscribe(
        () => {
          this.paperlessService.togglePaperlessPopup(false);
        },
        () => {
          this.paperlessService.togglePaperlessPopup(false);
        }
      );
  }

  enrollInPaperless() {
    this.router.navigate(['/billing/paperless']);
  }
}
